import { AuthModel } from "../services/models";

export {
  replaceOrderIdInIntegrationUrl,
  buildExternalIntegrationSubmitFormData,
  mergeExternalOrderIntoFormData,
  normalizeExternalDateSampledForForm,
  normalizeExternalPhoneForForm,
  normalizeExternalIntegrationList,
} from "./externalIntegration";

export const formatDate = (value) => {
  return new Date(value).toLocaleDateString("en-AU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const parseDate = (dateString) => {
  const [day, month, year] = dateString.split("/");
  return `${year}-${month}-${day}`;
};

export const isUserRoleUser = () => {
  const user = AuthModel.getUser();
  return user?.role === "user";
};

export const formatSamplingFor = (value = "") => {
  if (!value) return "";
  return value
    .split("-")
    .filter(Boolean)
    .map((segment) => segment[0]?.toUpperCase() + segment.slice(1))
    .join(" ");
};

export const getRelativeTimeFromNow = (dateValue) => {
  if (!dateValue) return "";
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "";

  const secondsDiff = Math.max(0, Math.floor((Date.now() - date.getTime()) / 1000));

  const units = [
    { label: "year", seconds: 60 * 60 * 24 * 365 },
    { label: "month", seconds: 60 * 60 * 24 * 30 },
    { label: "week", seconds: 60 * 60 * 24 * 7 },
    { label: "day", seconds: 60 * 60 * 24 },
    { label: "hour", seconds: 60 * 60 },
    { label: "minute", seconds: 60 },
  ];

  for (const unit of units) {
    if (secondsDiff >= unit.seconds) {
      const value = Math.floor(secondsDiff / unit.seconds);
      return `${value} ${unit.label}${value > 1 ? "s" : ""} ago`;
    }
  }

  return "Just now";
};
